var _rect, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJcbCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "0 0 40 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.25,
    width: 40,
    height: 25,
    rx: 1.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7345 14.839H31.3071C31.3874 14.839 31.5404 14.8288 31.6144 14.8156C32.1086 14.7291 32.52 14.3732 32.52 13.8891C32.52 13.4051 32.1086 13.0481 31.6144 12.9617C31.5417 12.9485 31.3886 12.9383 31.3071 12.9383H28.7345V14.839Z",
    fill: "url(#paint0_linear_28564_302683)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0073 1.69C28.5527 1.69 26.5633 3.30286 26.5633 5.293V9.03531H32.8524C32.9979 9.03531 33.1761 9.04345 33.2877 9.04853C34.7113 9.1065 35.7599 9.69937 35.7599 10.7275C35.7599 11.5359 35.0425 12.2275 33.7367 12.3831V12.4237C35.1792 12.5051 36.283 13.1478 36.283 14.1627C36.283 15.26 35.0713 15.9647 33.4558 15.9647H26.5633V23.31H33.082C35.5367 23.31 37.526 21.6961 37.526 19.707V1.69H31.0073Z",
    fill: "url(#paint1_linear_28564_302683)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2152 10.9888C32.2152 10.5129 31.8038 10.1936 31.3209 10.1275C31.2757 10.1214 31.1528 10.1112 31.0675 10.1112H28.7357V11.8654H31.0675C31.1528 11.8654 31.2757 11.8553 31.3209 11.8492C31.8038 11.7831 32.2152 11.4637 32.2152 10.9888Z",
    fill: "url(#paint2_linear_28564_302683)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41528 1.69C3.96059 1.69 1.97126 3.30286 1.97126 5.293V14.1912C3.21804 14.6803 4.50497 14.9996 5.81572 14.9996C7.35225 14.9996 8.19641 14.239 8.19641 13.2159V9.03531H12.0183V13.2159C12.0183 14.8512 10.7803 16.163 6.53193 16.163C3.97564 16.163 1.97 15.7155 1.97 15.7155V23.309H8.48866C10.9433 23.309 12.9327 21.6951 12.9327 19.706V1.69H6.41528Z",
    fill: "url(#paint3_linear_28564_302683)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7113 1.69C16.2566 1.69 14.2673 3.30286 14.2673 5.293V10.0106C15.3937 9.22751 17.3404 8.73837 20.505 8.85328C22.1983 8.9143 23.9945 9.28243 23.9945 9.28243V10.8078C23.0951 10.4387 22.0177 10.096 20.6292 10.0116C18.2284 9.86411 16.7834 10.816 16.7834 12.5C16.7834 14.184 18.2284 15.1349 20.6292 14.9874C22.0177 14.903 23.1102 14.5512 23.9945 14.1922V15.7166C23.9945 15.7166 22.1983 16.0847 20.505 16.1467C17.3416 16.2616 15.3937 15.7725 14.2673 14.9895V23.31H20.786C23.2406 23.31 25.23 21.6961 25.23 19.707V1.69H18.7113Z",
    fill: "url(#paint4_linear_28564_302683)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28564_302683",
    x1: 26.5628,
    y1: 13.8883,
    x2: 37.5541,
    y2: 13.8883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#008D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#4FAC48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62BB46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28564_302683",
    x1: 26.5626,
    y1: 12.4997,
    x2: 37.5542,
    y2: 12.4997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#008D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#4FAC48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62BB46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28564_302683",
    x1: 26.5626,
    y1: 10.9882,
    x2: 37.5536,
    y2: 10.9882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#008D49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#4FAC48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62BB46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28564_302683",
    x1: 1.95624,
    y1: 12.4997,
    x2: 13.1175,
    y2: 12.4997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#005999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#006FB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_28564_302683",
    x1: 14.2009,
    y1: 12.4997,
    x2: 25.0408,
    y2: 12.4997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#743237"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#8C3039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE273F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DF1E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1846"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbCard);
export default __webpack_public_path__ + "static/media/jcb-card.3bdf078cc9ec40716e94dd3d21907b4a.svg";
export { ForwardRef as ReactComponent };